{
  "login": {
    "genericError": "Si è verificato un errore durante l'accesso. Riprova."
  },
  "acceptTerms": {
    "pleaseAccept": "Accetta i Termini e condizioni per continuare",
    "accepted": "Termini e condizioni accettati",
    "failedGeneric": "Impossibile accettare i termini. Riprova."
  },
  "discord": {
    "linkSuccess": "Account Discord collegato! Verifica i tuoi DM qui sotto.",
    "linkFailed": "Impossibile collegare l'account Discord: {{message}}",
    "verificationSent": "Codice di verifica inviato ai tuoi DM Discord!",
    "dmVerified": "DM Discord verificati con successo! Le notifiche sono ora disponibili.",
    "settingToggled": "{{label}} {{state}}",
    "unlinked": "Account Discord scollegato con successo!",
    "userIdNotFound": "ID utente non trovato. Prova ad accedere nuovamente.",
    "clientIdNotConfigured": "ID client Discord non configurato. Controlla le variabili d'ambiente.",
    "redirectUriNotConfigured": "URL di reindirizzamento non configurato correttamente. Controlla le variabili d'ambiente.",
    "allowPopups": "Consenti i popup per questo sito per collegare il tuo account Discord",
    "linkFirst": "Collega prima il tuo account Discord",
    "sendCodeFailed": "Invio del codice di verifica fallito. Assicurati che il bot possa inviarti DM.",
    "sendCodeFailedGeneric": "Invio del codice di verifica fallito",
    "enterCode": "Inserisci il codice di verifica",
    "verifyCodeFailed": "Verifica del codice fallita. Riprova.",
    "verifyFirst": "Verifica prima i tuoi DM Discord",
    "updateSettingFailed": "Aggiornamento delle impostazioni di notifica fallito",
    "unlinkFailed": "Disconnessione dell'account Discord fallita",
    "categoryUpdated": "Categoria aggiornata",
    "categoryUpdateFailed": "Impossibile aggiornare la categoria",
    "categoryDeleted": "Categoria eliminata",
    "categoryDeleteFailed": "Impossibile eliminare la categoria",
    "defaultCategoryUpdated": "Categoria predefinita aggiornata",
    "setDefaultFailed": "Impossibile impostare la categoria predefinita",
    "categoryCreated": "Categoria creata",
    "categoryCreateFailed": "Impossibile creare la categoria"
  },
  "subscription": {
    "failedLoadPricing": "Impossibile caricare le informazioni sui prezzi",
    "failedCheckout": "Impossibile avviare il checkout",
    "failedChangeSubscription": "Impossibile modificare l'abbonamento",
    "failedOpenBillingPortal": "Impossibile aprire il portale di fatturazione",
    "cancelSuccess": "Il tuo abbonamento è stato annullato con successo",
    "cancelFailed": "Impossibile annullare l'abbonamento",
    "resumeSuccess": "Il tuo abbonamento è stato ripreso con successo",
    "resumeFailed": "Impossibile riprendere l'abbonamento",
    "updateSuccess": "Il tuo abbonamento è stato aggiornato!",
    "newSubscriptionSuccess": "Benvenuto! Il tuo abbonamento è ora attivo."
  },
  "trial": {
    "activated": "Prova attivata! Goditi 7 giorni di FlippingPal.",
    "activationFailed": "Impossibile attivare la prova"
  },
  "account": {
    "emailBothFieldsRequired": "Compila entrambi i campi",
    "emailInvalid": "Inserisci un indirizzo email valido",
    "emailUpdated": "Email aggiornata! Controlla la nuova email per confermare. Disconnessione in corso...",
    "emailFailed": "Impossibile cambiare l'email",
    "passwordAllFieldsRequired": "Compila tutti i campi della password",
    "passwordTooShort": "La nuova password deve contenere almeno 4 caratteri",
    "passwordsDoNotMatch": "Le nuove password non corrispondono",
    "passwordChanged": "Password cambiata con successo!",
    "passwordFailed": "Impossibile cambiare la password",
    "closeAccountPasswordRequired": "Inserisci la tua password",
    "closeAccountConfirmRequired": "Digita \"CHIUDI IL MIO ACCOUNT\" per confermare",
    "accountClosed": "Account chiuso. Disconnessione in corso...",
    "closeAccountFailed": "Impossibile chiudere l'account"
  },
  "snipe": {
    "ilvlEnterAtLeastOne": "Inserisci almeno un ilvl min o max",
    "ilvlValidMin": "Inserisci un ilvl min valido",
    "ilvlValidMax": "Inserisci un ilvl max valido",
    "ilvlMinExceedsMax": "L'ilvl min non può superare {{max}}",
    "ilvlMaxExceedsMax": "L'ilvl max non può superare {{max}}",
    "ilvlMinGreaterThanMax": "L'ilvl min non può essere superiore all'ilvl max",
    "ilvlValidPrice": "Inserisci un prezzo valido (es. 100g, 50g 30s, o 100)",
    "reqLvlMinRange": "Il livello min richiesto deve essere tra {{min}} e {{max}}",
    "reqLvlMaxRange": "Il livello max richiesto deve essere tra {{min}} e {{max}}",
    "reqLvlMinGreaterThanMax": "Il livello min richiesto non può essere superiore al livello max richiesto",
    "ilvlAdded": "Snipe ilvl aggiunto",
    "ilvlUpdated": "Snipe ilvl aggiornato",
    "ilvlSaveFailed": "Impossibile salvare lo snipe ilvl",
    "ilvlRemoved": "Snipe ilvl rimosso",
    "ilvlRemoveFailed": "Impossibile rimuovere lo snipe ilvl",
    "selectItem": "Seleziona un oggetto",
    "validPetId": "Inserisci un ID mascotta valido o cerca una mascotta",
    "invalidPrice": "Inserisci un prezzo valido (es. 100g, 50g 30s, o 100)",
    "itemAdded": "Snipe {{label}} aggiunto",
    "itemUpdated": "Snipe {{label}} aggiornato",
    "itemAddFailed": "Impossibile aggiungere lo snipe {{type}}",
    "itemRemoved": "Snipe {{type}} rimosso",
    "itemRemoveFailed": "Impossibile rimuovere lo snipe {{type}}",
    "editingWoWToken": "Modifica avviso snipe WoW Token",
    "editingSnipeAlert": "Modifica avviso snipe per {{name}}",
    "itemNotFound": "{{label}} non trovato.",
    "importInvalidArrayFormat": "Formato non valido. È atteso un array di regole snipe ilvl.",
    "importNoValidEntries": "Nessuna voce valida trovata. Gli elementi dell'array necessitano dei campi \"{{idKey}}\" e \"price\".",
    "importInvalidJsonFormat": "Formato JSON non valido. Atteso { {{idKey}}: goldPrice, ... } o un array di oggetti.",
    "importSuccess": "Importazione: {{added}} aggiunto/i, {{updated}} aggiornato/i, {{skipped}} ignorato/i",
    "importIlvlSuccess": "Importate {{count}} regola/e snipe ilvl",
    "importParseFailed": "Impossibile analizzare o importare il JSON",
    "noItemsToExport": "Nessun {{type}} da esportare",
    "noIlvlItemsToExport": "Nessun oggetto ilvl da esportare",
    "exportSuccess": "Esportato/i {{count}} {{type}}",
    "exportIlvlSuccess": "Esportato/i {{count}} oggetti ilvl",
    "enabledToggle": "Avvisi snipe {{state}}",
    "enabledToggleFailed": "Impossibile aggiornare l'impostazione snipe",
    "alertStyleUpdated": "Stile avviso impostato su {{style}}",
    "alertStyleFailed": "Impossibile aggiornare lo stile avviso",
    "realmsSaved": "Regni snipe salvati",
    "realmsSaveFailed": "Impossibile salvare i regni snipe",
    "clearAllConfirm": "Sei sicuro di voler rimuovere tutti gli snipe {{label}}?",
    "clearAllSuccess": "Tutti gli snipe {{label}} eliminati",
    "clearAllFailed": "Impossibile eliminare gli snipe {{label}}",
    "cooldownCyclesUpdated": "Tempo di ricarica impostato a {{cycles}} cicli saltati",
    "cooldownCyclesFailed": "Impossibile aggiornare il tempo di ricarica",
    "cooldownCyclesInvalid": "Il tempo di ricarica deve essere compreso tra 0 e 24 cicli",
    "undo": "Ripristina",
    "undoRestored": "Avviso snipe ripristinato",
    "undoFailed": "Impossibile ripristinare l'avviso snipe",
    "priceUpdated": "Prezzo aggiornato",
    "priceUpdateFailed": "Impossibile aggiornare il prezzo"
  },
  "personalConfig": {
    "saveSuccess": "Filtri predefiniti salvati con successo!",
    "saveFailed": "Impossibile salvare i filtri predefiniti"
  },
  "auth": {
    "registrationSuccessEmail": "Registrazione riuscita! Controlla la tua email per la verifica.",
    "registrationSuccessLogin": "Registrazione riuscita! Accedi con il tuo nuovo account.",
    "passwordResetSuccess": "Password reimpostata con successo"
  },
  "common": {
    "networkError": "Errore di rete. Riprova."
  },
  "validation": {
    "passwordRequired": "La password è obbligatoria",
    "passwordMinLength": "La password deve contenere almeno {{count}} caratteri",
    "passwordUppercase": "La password deve contenere almeno una lettera maiuscola",
    "passwordLowercase": "La password deve contenere almeno una lettera minuscola",
    "passwordNumber": "La password deve contenere almeno un numero",
    "passwordSpecialChar": "La password deve contenere almeno un carattere speciale",
    "confirmPasswordRequired": "Si prega di confermare la password",
    "passwordsDoNotMatch": "Le password non corrispondono",
    "emailRequired": "L'e-mail è obbligatoria",
    "emailInvalid": "Inserisci un indirizzo e-mail valido"
  },
  "filterPreset": {
    "fetchFailed": "Impossibile caricare i preset di filtro",
    "createFailed": "Impossibile creare il preset di filtro",
    "updateFailed": "Impossibile aggiornare il preset di filtro",
    "deleteFailed": "Impossibile eliminare il preset di filtro",
    "invalidImportNotObject": "Stringa di importazione non valida: non è un oggetto preset valido",
    "invalidImportMissingVersion": "Stringa di importazione non valida: informazioni sulla versione mancanti",
    "invalidImportMissingPreset": "Stringa di importazione non valida: dati preset mancanti",
    "invalidPresetMissingName": "Preset non valido: nome mancante o non valido",
    "invalidPresetMissingFilters": "Preset non valido \"{{name}}\": filtri mancanti o non validi"
  }
}
